import React, { Component } from "react";
import * as endpoint from "./../../../Service/endpoints";
import * as service from "./../../../Service/service";
import LoginWrapper from "./../../User/Login/LoginWrapper";
import MdBasket from "react-ionicons/lib/MdBasket";
import MdPerson from "react-ionicons/lib/MdPerson";
import { connect } from "react-redux";

import IosArrowDown from "react-ionicons/lib/IosArrowDown";

import MainSidebar from "./MainSidebar";
import { NavLink } from "react-router-dom/cjs/react-router-dom";

class HeaderComponent extends Component {
  state = {
    searchElem: "",
  };

  searchItem = () => {
    window.location.href =
      window.location.origin + "/search/" + this.state.searchElem;
  };

  constructor(props) {
    super(props);
    this.child = React.createRef();
  }

  showLoginModal = () => {
    if (this.props.userState.loggedIn) {
      window.location.href = "/account";
    } else {
      this.props.showLoginModal();
    }
  };

  openMenu = () => {
    this.props.openUserMenu();
  };

  componentDidMount() {
    if (typeof localStorage.keycloak != "undefined") {
      let keycloak = JSON.parse(localStorage.keycloak);
      this.props.loginUser(keycloak);
      this.getLoginInfo();
    }
  }

  getLoginInfo = () => {
    service.getUserInfo().then(
      (response) => {
        this.props.updateUserInfo(response.data);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  onSearchSelect = (event) => {
    this.setState({
      ...this.state,
      searchElem: event.target.value,
    });
  };

  _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.searchItem();
    }
  };

  render() {
    const currentCity = endpoint.getCurrentCity();
    return (
      <nav
        className="navbar navbar-expand-lg navbar-light"
        style={{ height: "80px", borderBottom: "2px solid #f8f9fa!important", position: "fixed", top: "0px", width: "100%", zIndex: "1000", backgroundColor: "rgba(255,255,255,0.9)"}}
      >
        {
          // Desktop Header
        }
        <div
          className="d-none d-sm-block"
          style={{ margin: "0px 0px", width: "100%"}}
        >
          <div className="navbar navbar-expand-lg">
            <a className="navbar-brand" href={endpoint.getRoute("")}>
              <img
                height="35px;"
                src="data:image/png;base64,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"
                alt=""
              />
            </a>

            <div
              className="collapse navbar-collapse justify-content-between"
              id="navbarSupportedContent"
            >
              <div className="" style={{ minWidth: "20%", marginLeft:'15%' }}>
                <input
                  type="search"
                  size="55"
                  onChange={this.onSearchSelect}
                  onKeyDown={this._handleKeyDown}
                  className="form-control mdb-autocomplete"
                  placeholder="Search for products...."
                  style={{ border: "none", background: "#F5F9FC", borderRadius: '30px' }}
                />
              </div>
              <ul className="navbar-nav " >
                <li className="nav-item active" style={{fontSize:'16px'}}>
                  <a className="nav-link" href={endpoint.getRoute("")} >
                    Home
                  </a>
                </li>
                <li className="nav-item" style={{fontSize:'16px'}}>
                  <a className="nav-link" href={endpoint.getRoute("furniture")} >
                    Furniture
                  </a>
                </li>
                <li className="nav-item" style={{fontSize:'16px'}}>
                  <a className="nav-link" href={endpoint.getRoute("appliance")} >
                    Appliances
                  </a>
                </li>
                <li className="nav-item" style={{fontSize:'16px'}}>
                  <a className="nav-link" href={endpoint.getRoute("package")} >
                    Packages
                  </a>
                </li>
                <li className="nav-item" style={{fontSize:'16px'}}>
                  <a className="nav-link" href={endpoint.getRoute("seasonal")} >
                  Seasonal
                  </a>
                </li>
                <li className="nav-item" style={{fontSize:'16px'}}>
                  <a className="nav-link" href={endpoint.getRoute("premium")} >
                    Premium
                  </a>
                </li>
                {currentCity === "gurgaon" && (
                <li className="nav-item" style={{fontSize:'16px'}}>
                  <a className="nav-link" href={endpoint.getRoute("expressDelivery")} >
                    Express Delivery
                  </a>
                </li>
                )}
                
                {/* <li className="nav-item" style={{fontSize:'16px'}}>
                <NavLink className="nav-link" to="/customization">Customization</NavLink>
                </li> */}
                <li className="nav-item" style={{fontSize:'16px'}}>
                  <a
                    className="nav-link"
                    style={{ color: "rgb(0 74 128)",  fontWeight: 'bold'  }}
                    href="https://parvhomes.com/"
                  >
                    Buy Now
                  </a>
                </li>

                <div
                  onClick={this.props.selectCityOpen}
                  className="nav-item change-city ml-2"
                  style={{ borderColor: "#000000", borderRadius: "6px", border: "1px solid", padding: "7px", fontSize:'16px'}}
                >
                  <div className="text-capitalize" style={{ marginTop: '4px' }}>
                    <span color="#999">
                      {currentCity}
                      <IosArrowDown color="#999" />
                    </span>
                  </div>
                </div>

                <li className="nav-item  ml-2" >
                  <a href="/cart" className="ml-1 mr-1 ">
                    <img width="40" height="40"  src="https://voorent.com/voorent-storage/images/shopping-cart.png" alt="experimental-shopping-cart-comic" />
                    {/* <MdBasket fontSize="32px" color="#e8554e" /> */}
                  </a>
                </li>
                <li className="nav-item ml-2 ">
                  <div className="" style={{ cursor: "pointer" }}>
                    <img width="48" height="48" src="https://img.icons8.com/ios/50/user-male-circle--v1.png" alt="user-male-circle--v1" onClick={this.showLoginModal} />
                    {/* <MdPerson
                      onClick={this.showLoginModal}
                      fontSize="36px"
                      color="#f8f9fa"
                    /> */}
                  </div>
                </li>
                {/* <li className="ml-2 ">
                  <div className="person">
                    <MdPerson
                      onClick={this.showLoginModal}
                      fontSize="36px"
                      color="#f8f9fa"
                    />
                  </div>
                </li> */}
              </ul>
            </div>
          </div>
        </div>

        {
          // Mobile Header
        }

        <div className="d-block d-sm-none">
          <div style={{ padding: "0px" }} className="navbar navbar-expand-lg">
            <div className="row">
              <div className="col-2 mt-2" onClick={this.openMenu}>
                <button className="btn btn-outline-light mr-2">
                  <span className="navbar-toggler-icon"></span>
                </button>
              </div>
              <div className="col-6 mt-2">
                <a className="navbar-brand" href={endpoint.getRoute("")}>
                  <img
                    height="28px;"
                    src="data:image/png;base64,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"
                    alt=""
                    
                  />
                </a>
              </div>
              <div className="col-2 mt-3" >
                <a href="/cart" className="">
                  <MdBasket fontSize="34px" color="#e8554e"  />
                </a>
              </div>
              <div className="col-2 mt-3">
                <div className="person-small">
                  <MdPerson
                    onClick={this.showLoginModal}
                    fontSize="32px"
                    color="#f8f9fa"
                    style={{marginLeft:'30%'}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <MainSidebar />

        <LoginWrapper />
      </nav>
    );
  }
}

const mapStateToProps = (currentState) => {
  return {
    userState: currentState.userState,
  };
};

const mapActionsToProps = (dispatch) => {
  return {
    showLoginModal: () => {
      dispatch({ type: "login.window.show" });
    },
    loginUser: (data) => {
      dispatch({ type: "user.auth.login", data: data });
    },
    updateUserInfo: (data) => {
      dispatch({ type: "login.update.userInfo", data: data });
    },
    openUserMenu: () => {
      dispatch({ type: "user.menu.show" });
    },
    selectCityOpen: () => {
      dispatch({ type: "user.city.show" });
    },
  };
};

export default connect(mapStateToProps, mapActionsToProps)(HeaderComponent);
